import Cookies from 'js-cookie';
import { IframeService } from '../../core/iframe.service';

export function setCookie(name: string, value: string, lifespan = 15)
{
  if (value !== undefined && value !== 'undefined') {
    const lifespanInDays = lifespan / 1440;
    Cookies.set(name, value, {expires: lifespanInDays, secure: true, sameSite: IframeService.runsInIframe() ? 'None' : 'Strict'});
  }
}

export function getCookie(name: string): string
{
  return Cookies.get(name);
}

export function removeCookie(name: string): void
{
  Cookies.remove(name);
}

export function clearCookies(): void
{
  Object.keys(Cookies.get())
    .forEach((name) => removeCookie(name));
}
